import { PButtonPure, PHeadline } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import { PortalContext } from '../../../utils/PortalContext'

import styles from './drawerheader.module.css'

type Props = {
  leftDrawer?: boolean
}

const DrawerHeader = ({ leftDrawer }: Props) => {
  const { setOpenDrawer, drawerContent, drawerData } = React.useContext(PortalContext)

  const getDrawerTitle = () => {
    if (drawerContent === 'EditApp') {
      return drawerData.appInformation.title + ' bearbeiten'
    }
    if (drawerContent === 'DetailsApp') {
      return drawerData.appInformation.title
    }
    if (drawerContent === 'NewSubApp') {
      return 'Unterbereich hinzufügen'
    }
    return 'Applikation hinzufügen'
  }

  return (
    <header className={clsx(styles.header, { [styles.headerLeftDrawer]: leftDrawer })}>
      <PButtonPure hideLabel icon='close' size='small' className={styles.close} onClick={() => setOpenDrawer(false)}>
        Schließen
      </PButtonPure>
      <PHeadline variant='headline-4' className={styles.title}>
        {getDrawerTitle()}
      </PHeadline>
    </header>
  )
}

export default DrawerHeader
